import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.17.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.18_better-sqli_ed9a79f002afd2f658fe33f0c15645e1/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/app/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}